import { override } from 'flarum/common/extend';
export default function leaderboard(app) {
  const LeaderBoardState = flarum.extensions['nodeloc-leaderboard']?.LeaderBoardState;
  override(LeaderBoardState.prototype, 'sortMap', function (original) {
    const map = original();
    map['most_exp'] = '-exp';
    map['least_exp'] = 'exp';
    return map;
  });
  const components = flarum.extensions['nodeloc-leaderboard']?.components;
  if (!components) return;
  const LeaderBoardUserCard = components?.LeaderBoardUserCard;
  override(LeaderBoardUserCard.prototype, 'view', function (original) {
    const user = this.attrs.user;
    const sort = this.attrs.params.sort;
    if (sort === 'most_exp' || sort === 'least_exp') {
      this.attrs.params.sort = 'exp';
    }
    return original();
  });
  const SmallUserCard = components?.SmallUserCard;
  override(SmallUserCard.prototype, 'view', function (original) {
    const user = this.attrs.user;
    const sort = this.attrs.params.sort;
    if (sort === 'most_exp' || sort === 'least_exp') {
      this.attrs.params.sort = 'exp';
    }
    return original();
  });
}
flarum.reg.add('foskym-custom-levels', 'forum/integrations/leaderboard', leaderboard);